document.addEventListener('DOMContentLoaded', function () {
  // Rota los mensajes de la barra de anuncio cada 4 segundos
  var messages = document.querySelectorAll('.announcement-bar__track p');
  if (messages.length > 1) {
    var current = 0;
    messages.forEach(function (m, i) { m.style.display = i === 0 ? 'block' : 'none'; });
    setInterval(function () {
      messages[current].style.display = 'none';
      current = (current + 1) % messages.length;
      messages[current].style.display = 'block';
    }, 4000);
  }
});
